"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = void 0;
var _tabs = require("../../types/tabs");
const defaultState = exports.defaultState = _tabs.EActiveTab.Authentication;